/* eslint-disable */
import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import useNotifier from "@saleor/hooks/useNotifier";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Grid from "@saleor/components/Grid";
import { MetadataFormData } from "@saleor/components/Metadata";
import Metadata from "@saleor/components/Metadata/Metadata";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import SeoForm from "@saleor/components/SeoForm";
import { VariantAvailabilityCard } from "@saleor/components/VariantAvailabilityCard";
import { ProductErrorWithAttributesFragment } from "@saleor/fragments/types/ProductErrorWithAttributesFragment";
import { ProductVariant } from "@saleor/fragments/types/ProductVariant";
import { WarehouseFragment } from "@saleor/fragments/types/WarehouseFragment";
import useDateLocalize from "@saleor/hooks/useDateLocalize";
import { FormsetData } from "@saleor/hooks/useFormset";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { ExtraChargeCategoryData } from "@saleor/products/types/ExtraChargeCategoryData";
// import { InstagramsByProductsId_instagramsByProductsId } from "@saleor/products/types/InstagramsByProductsId";
import { ProductVariantDetails_productVariant_images } from "@saleor/products/types/ProductVariantDetails";
import { VariantUpdate_productVariantUpdate_errors } from "@saleor/products/types/VariantUpdate";
import { SearchCornermarks_search_edges_node } from "@saleor/searches/types/SearchCornermarks";
import { SearchExtracharges_search_edges_node } from "@saleor/searches/types/SearchExtracharges";
import { ReorderAction } from "@saleor/types";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { FetchMoreProps } from "../../../types";
import ProductDescription from "../ProductDescription/ProductDescription";
// import ProductExtraCharge from "../ProductExtraCharge/ProductExtraCharge";
import ProductShipping from "../ProductShipping/ProductShipping";
import ProductSkuAttributes, {
  SkuAttributeInputData
} from "../ProductSkuAttributes";
import ProductStocks, { ProductStockInput } from "../ProductStocks";
import ProductVariantAttributes, {
  VariantAttributeInputData
} from "../ProductVariantAttributes";
import ProductVariantCornermarks from "../ProductVariantCornermarks";
// import ProductVariantIns from "../ProductVariantIns";
import ProductVariantNavigation from "../ProductVariantNavigation";
import ProductVariantPrice from "../ProductVariantPrice";
import ProductVariantSetDefault from "../ProductVariantSetDefault";
import VariantImages from "../VariantImages";
import ProductVariantUpdateForm from "./form";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
// import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import { createPaginationState } from "@saleor/hooks/usePaginator";
import { useProducttagsListQuery } from "@saleor/producttags/queries";
// import { ProducttagsListUrlQueryParams } from "@saleor/producttags/urls";
import { PAGINATE_BY } from "@saleor/config";
import ProductVariantColor from "../ProductVariantColor";
import {
  useProductVariantCopyCreateMutation,
  useClearImagesByVariantIdMutation
} from "../../mutations";
import { SkuExtraChargeCategory_skuExtraChargeCategory } from "@saleor/products/types/SkuExtraChargeCategory";
import ProductVariantGetErp from "../ProductVariantGetErp";
import { GetErpProductVariant_erpProductVariant } from "@saleor/products/types/GetErpProductVariant";
import { Card, CardContent } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      width: "380px",
      borderRadius: "4px"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
let selectList = [];
// let myIndex = 0;

export interface ProductVariantPageFormData extends MetadataFormData {
  costPrice: string;
  price: string;
  sku: string;
  trackInventory: boolean;
  weight: string;
  // extraCharge: string;
  fromColor: string;
  toColor: string;
  isTwoColor: boolean;
  colorThumbnail: string;
  shortDescription: string;
  fullDescription: string;
  describe: string;
  USP: string;
  skuName: string;
  slug: string;
  seoTitle: string;
  seoKeyword: string;
  seoDescription: string;
  framesImg: string;
  framesVideo: string;
  isPublished: boolean;
  publicationDate: string;
  extraChargeCategory: string;
  cornermark: string;
  availableForPurchaseDate: string;
  availableForPurchaseTime: string;
  isAvailableForPurchase: boolean;
  preOrderDate: string;
  preOrderTime: string;
  isPreOrder: boolean;
  colorTagText: string;
  colorTagBackground: string;
  colorTagTextColor: string;
  // colorTagIcon: string;
}

export interface ProductVariantPageSubmitData
  extends ProductVariantPageFormData {
  colorTagTextColor: any;
  attributes: FormsetData<VariantAttributeInputData, string>;
  skuAttributes: FormsetData<SkuAttributeInputData, string>;
  addStocks: ProductStockInput[];
  updateStocks: ProductStockInput[];
  removeStocks: string[];
}

// let idList = [];

interface ProductVariantPageProps {
  // 配镜方案下拉框
  setNewSku?: Dispatch<SetStateAction<string>>;
  extraChargeCategoryData?: ExtraChargeCategoryData;
  extraChargeCategory?: string;
  setExtraChargeCategory?: Dispatch<SetStateAction<string>>;
  activeSkuExtraChargeCategory?: (id, isActive) => void;
  skuExtraChargeCategory?: SkuExtraChargeCategory_skuExtraChargeCategory[];
  // end
  defaultVariantId?: string;
  defaultWeightUnit: string;
  cornermarks?: SearchCornermarks_search_edges_node[];
  extracharges?: SearchExtracharges_search_edges_node[];
  errors:
    | ProductErrorWithAttributesFragment[]
    | VariantUpdate_productVariantUpdate_errors[];
  fetchCornermarks?: (data: string) => void;
  fetchExtracharges?: (data: string) => void;
  fetchMoreCornermarks?: FetchMoreProps;
  fetchMoreExtracharges?: FetchMoreProps;
  header: string;
  loading?: boolean;
  placeholderImage?: string;
  saveButtonBarState: ConfirmButtonTransitionState;
  variant?: ProductVariant;
  images?: ProductVariantDetails_productVariant_images[];
  warehouses: WarehouseFragment[];
  // productIns?: InstagramsByProductsId_instagramsByProductsId[];
  onVariantReorder: ReorderAction;
  onAdd();
  onBack();
  onDelete();
  onSeoClick?();
  onSubmit(data: ProductVariantPageSubmitData);
  // onImageSelect(id: string);
  onImageDelete(id: string);
  onImageEdit?(id: string);
  onImageReorder?(event: { oldIndex: number; newIndex: number });
  onImageSetFirst(id: string);
  onImageUpload(file: File);
  onImageFetch(variantId: string);
  onVariantClick(variantId: string);
  onSetDefaultVariant();
  onWarehouseConfigure();
  params?: any;
  onGetErpData: (erpSku: string) => void;
  erpProductVariant: GetErpProductVariant_erpProductVariant;
  onVisibleEdit?: (id: string) => void;
}

const ProductVariantPage: React.FC<ProductVariantPageProps> = ({
  // 配镜方案下拉框
  setNewSku,
  extraChargeCategoryData,
  extraChargeCategory,
  setExtraChargeCategory,
  activeSkuExtraChargeCategory,
  skuExtraChargeCategory,
  // end
  defaultVariantId,
  defaultWeightUnit,
  cornermarks: cornermarkChoiceList,
  extracharges: extrachargeChoiceList,
  errors,
  fetchCornermarks,
  fetchMoreCornermarks,
  header,
  loading,
  placeholderImage,
  saveButtonBarState,
  variant,
  images,
  warehouses,
  // productIns,
  onAdd,
  onBack,
  onDelete,
  onImageDelete,
  onImageEdit,
  onImageReorder,
  onImageSetFirst,
  onImageUpload,
  onImageFetch,
  onSeoClick,
  onSubmit,
  onVariantClick,
  onVariantReorder,
  onSetDefaultVariant,
  onWarehouseConfigure,
  onVisibleEdit,
  params,
  onGetErpData,
  erpProductVariant
}) => {
  const intl = useIntl();
  const localizeDate = useDateLocalize();
  const [selectedCornermark, setSelectedCornermark] = useStateFromProps(
    variant?.cornerMark?.titleText || ""
  );
  const [colorThumbnail, setColorThumbnail] = useStateFromProps(
    variant?.colorThumbnail || ""
  );
  // const [colorTagIcon, setColorTagIcon] = useStateFromProps(
  //   variant?.colorTagIcon || ""
  // );
  // console.log("colorTagIcon====>", colorTagIcon);
  const notify = useNotifier();

  const paginationState = createPaginationState(PAGINATE_BY, params);
  const queryVariables = React.useMemo(
    () => ({
      ...paginationState
    }),
    [params]
  );

  const { data } = useProducttagsListQuery({
    variables: queryVariables
  });

  selectList = [];
  const producttagsList = [];
  if (data) {
    data.producttags.edges.forEach(item => {
      const obj = {
        text: "",
        id: ""
      };
      obj.text = item.node.name;
      obj.id = item.node.id;
      selectList.push(item.node.name);
      producttagsList.push(obj);
    });
  }
  const classes = useStyles();
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [idList1, setidList] = React.useState<string[]>([]);
  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    setPersonName(event.target.value as string[]);
    let idList = [];

    producttagsList.forEach(item => {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < event.target.value.length; i++) {
        if (event.target.value[i] === item.text) {
          idList.push(item.id);
        }
      }
    });
    setidList(idList);
  };

  if (personName.length == 0) {
    // isrender = false;
  }

  useEffect(() => {
    if (!variant) {
      return undefined;
    }
    if (variant.productvarianttagsSku.length == 0) {
      setPersonName([]);
      setidList([]);
      // idList=[]
    } else {
      let personName1 = [];
      let idList1 = [];
      variant.productvarianttagsSku.forEach(item => {
        // if (myIndex === 1) {
        personName1.push(item.name);
        setPersonName(personName1);
        idList1.push(item.id);
        setidList(idList1);
        // idList.push(item.id);
        // }
      });
    }
    // }
  }, [variant]);

  const getCookie = name => {
    let arr;
    const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    // eslint-disable-next-line
    if ((arr = document.cookie.match(reg))) {
      return arr[2];
    } else {
      return null;
    }
  };

  // 保存选中的
  const savaSelect = () => {
    fetch(localStorage.getItem("shop_api_uri"), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "JWT " + getCookie("dashboardToken")
      },
      method: "POST",
      body: JSON.stringify({
        operationName: null,
        query:
          'mutation {\n  skutagsChoiceCreate(productvariantId: "' +
          variant.id +
          '", typeNumber: "1", producttags: ' +
          JSON.stringify(idList1) +
          ") {\n    producttagsErrors {\n      field\n      message\n      code\n    }\n    productvariant {\n      id\n      producttags {\n        id\n        name\n      }\n    }\n  }\n}\n",
        variables: {}
      }),
      mode: "cors" // no-cors, cors, *same-origin
    })
      .then(function(response) {
        if (response.status === 200) {
          // personName.splice(0, personName.length);
          document.querySelector<HTMLElement>(
            ".AppLayout-appAction-32"
          ).style.position = "sticky";
          return false;
        }
      })
      .catch(err => {
        console.error("错误", err);
      });
  };

  const cornermarks = maybe(() => cornermarkChoiceList, []).map(cornermark => ({
    label: cornermark.titleText,
    value: cornermark
  }));
  const extracharges = maybe(() => extrachargeChoiceList, []).map(
    extracharge => ({
      label: extracharge.categoryName,
      value: extracharge
    })
  );

  const [extraChargeCategoryOpts, setExtraChargeCategoryOpts] = useState<
    string[]
  >([]);
  useEffect(() => {
    setExtraChargeCategoryOpts(extraChargeCategoryData?.extraChargeCategory);
  }, [extraChargeCategoryData]);

  const [clearImagesByVariantId] = useClearImagesByVariantIdMutation({
    onCompleted: data => {
      if (data.clearImagesByVariantId.errors.length === 0) {
        notify({
          status: "success",
          text: "Clearing Image Succeeded"
        });
      }
    }
  });

  const [productVariantCopyCreate] = useProductVariantCopyCreateMutation({
    onCompleted: data => {
      if (data.productVariantCopyCreate.errors.length === 0) {
        notify({
          status: "success",
          text: "Copy Success"
        });
      }
    }
  });

  const onCopy = async id => {
    const result = await productVariantCopyCreate({
      variables: {
        id
      }
    });
    return result.data.productVariantCopyCreate.errors;
  };
  const onClearImage = (id: string) => () => {
    clearImagesByVariantId({
      variables: {
        variantId: id
      }
    });
  };
  const allActive = skuExtraChargeCategory?.map(SECC => {
    if (SECC.isActive) {
      return true;
    } else {
      return false;
    }
  });
  const [hasAllTrue, setHasAllTrue] = React.useState(
    !!!allActive?.includes(false)
  );
  useEffect(() => {
    // console.log(!!!allActive?.includes(false));
    setHasAllTrue(!!!allActive?.includes(false));
  }, [allActive]);

  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {maybe(() => variant.product.name)}
        </AppHeader>
        <PageHeader title={header}>
          {variant?.product?.defaultVariant?.id !== variant?.id && (
            <ProductVariantSetDefault
              onSetDefaultVariant={onSetDefaultVariant}
            />
          )}
        </PageHeader>
        <ProductVariantUpdateForm
          variant={variant}
          onSubmit={onSubmit}
          cornermarks={cornermarks}
          extracharges={extracharges}
          colorThumbnail={colorThumbnail}
          // colorTagIcon={colorTagIcon}
          setSelectedCornermark={setSelectedCornermark}
          setSelectedExtracharge={setExtraChargeCategory}
          warehouses={warehouses}
          erpProductVariant={erpProductVariant}
        >
          {({ change, data, handlers, submit }) => (
            <>
              <Grid variant="inverted">
                <div>
                  <ProductVariantNavigation
                    current={variant ? variant.id : undefined}
                    defaultVariantId={defaultVariantId}
                    fallbackThumbnail={maybe(
                      () => variant.product.thumbnail.url
                    )}
                    variants={maybe(() => variant.product.variants)}
                    onAdd={onAdd}
                    onCopy={onCopy}
                    onRowClick={(variantId: string) => {
                      if (variant) {
                        return onVariantClick(variantId);
                      }
                    }}
                    onReorder={onVariantReorder}
                  />
                  <CardSpacer />
                  <VariantAvailabilityCard
                    data={data}
                    errors={errors}
                    disabled={loading}
                    messages={{
                      hiddenLabel: intl.formatMessage({
                        defaultMessage: "Not published",
                        description: "product label"
                      }),
                      hiddenSecondLabel: intl.formatMessage(
                        {
                          defaultMessage: "will become published on {date}",
                          description: "product publication date label"
                        },
                        {
                          date: localizeDate(data.publicationDate, "L")
                        }
                      ),
                      visibleLabel: intl.formatMessage({
                        defaultMessage: "Published",
                        description: "product label"
                      })
                    }}
                    onChange={change}
                    firstPublicationDate={variant?.firstPublicationDate}
                    Create={variant?.created}
                  />
                  <CardSpacer />
                  <ProductVariantCornermarks
                    cornermarks={cornermarks}
                    cornermarkInputDisplayValue={selectedCornermark}
                    data={data}
                    disabled={loading}
                    errors={errors}
                    fetchCornermarks={fetchCornermarks}
                    fetchMoreCornermarks={fetchMoreCornermarks}
                    onCornermarkChange={handlers.selectCornermark}
                  />
                  <CardSpacer />

                  <Card>
                    <CardTitle
                      title={intl.formatMessage({
                        defaultMessage: "ProductTags",
                        description: "section header"
                      })}
                    />
                    <CardContent>
                      <FormControl className={classes.root}>
                        <Select
                          labelId="demo-mutiple-checkbox-label"
                          id="demo-mutiple-checkbox"
                          style={{ paddingLeft: "12px" }}
                          multiple
                          value={personName}
                          onChange={handleChange}
                          input={<Input />}
                          renderValue={selected =>
                            (selected as string[]).join(", ")
                          }
                          MenuProps={MenuProps}
                        >
                          {selectList.map(name => (
                            <MenuItem key={name} value={name}>
                              {/* <Checkbox checked={true} /> */}
                              <Checkbox
                                checked={personName.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </CardContent>
                  </Card>
                  <CardSpacer />
                  <ProductVariantColor
                    isTwoColor={data?.isTwoColor}
                    fromColor={data?.fromColor}
                    toColor={data?.toColor}
                    colorThumbnail={data?.colorThumbnail}
                    setColorThumbnail={setColorThumbnail}
                    onChange={change}
                    disabled={loading}
                    colorTagText={data?.colorTagText}
                    colorTagBackground={data?.colorTagBackground}
                    colorTagTextColor={data?.colorTagTextColor}
                    // colorTagIcon={data?.colorTagIcon}
                    // setColorTagIcon={setColorTagIcon}
                  />
                </div>
                <div>
                  <ProductVariantGetErp
                    sku={data?.sku}
                    disabled={loading}
                    errors={errors}
                    onChange={change}
                    onGetErpData={onGetErpData}
                  />
                  <CardSpacer />
                  <ProductVariantAttributes
                    attributes={data.attributes}
                    disabled={loading}
                    errors={errors}
                    onChange={handlers.selectAttribute}
                  />
                  <CardSpacer />
                  <ProductSkuAttributes
                    attributes={data.skuAttributes}
                    disabled={loading}
                    errors={errors}
                    onChange={handlers.selectSkuAttribute}
                  />
                  <CardSpacer />
                  <VariantImages
                    images={images}
                    variant={variant}
                    placeholderImage={placeholderImage}
                    onImageDelete={onImageDelete}
                    onImageReorder={onImageReorder}
                    onImageEdit={onImageEdit}
                    onImageUpload={onImageUpload}
                    onImageSetFirst={onImageSetFirst}
                    onImageFetch={onImageFetch}
                    onClearImage={onClearImage}
                    onVisibleEdit={onVisibleEdit}
                  />
                  <CardSpacer />
                  <ProductVariantPrice
                    data={data}
                    errors={errors}
                    currencySymbol={
                      variant && variant.price
                        ? variant.price.currency
                        : variant && variant.costPrice
                        ? variant.costPrice.currency
                        : ""
                    }
                    loading={loading}
                    onChange={change}
                  />
                  <CardSpacer />
                  <ProductStocks
                    data={data}
                    disabled={loading}
                    hasVariants={true}
                    errors={errors}
                    stocks={data.stocks}
                    warehouses={warehouses}
                    onChange={handlers.changeStock}
                    onFormDataChange={change}
                    onWarehouseStockAdd={handlers.addStock}
                    onWarehouseStockDelete={handlers.deleteStock}
                    onWarehouseConfigure={onWarehouseConfigure}
                    // 配镜方案下拉框
                    setNewSku={setNewSku}
                    hasAllTrue={hasAllTrue}
                    extraChargeCategoryOpts={extraChargeCategoryOpts}
                    extraChargeCategory={extraChargeCategory}
                    setExtraChargeCategory={setExtraChargeCategory}
                    onExtrachargeChange={handlers.selectExtracharge}
                    activeSkuExtraChargeCategory={activeSkuExtraChargeCategory}
                    skuExtraChargeCategory={skuExtraChargeCategory}
                    // end
                  />
                  <CardSpacer />
                  {/* <ProductVariantIns
                    productIns={productIns}
                  ></ProductVariantIns> 
                  <CardSpacer /> */}
                  {/* <ProductExtraCharge
                    data={data}
                    disabled={loading}
                    errors={errors}
                    onChange={change}
                  /> */}
                  <CardSpacer />
                  <ProductShipping
                    data={data}
                    disabled={loading}
                    errors={errors}
                    weightUnit={variant?.weight?.unit || defaultWeightUnit}
                    onChange={change}
                  />
                  <CardSpacer />

                  <SeoForm
                    errors={errors}
                    title={data.seoTitle}
                    keyword={data.seoKeyword}
                    titlePlaceholder={data.skuName}
                    keywordPlaceholder={data.skuName}
                    description={data.seoDescription}
                    descriptionPlaceholder={data.fullDescription}
                    slug={data.slug}
                    slugPlaceholder={data.skuName}
                    loading={loading}
                    onClick={onSeoClick}
                    onChange={change}
                    helperText={intl.formatMessage({
                      defaultMessage:
                        "Add search engine title and description to make this product sku easier to find"
                    })}
                  />
                  <CardSpacer />
                  <ProductDescription
                    data={data}
                    disabled={loading}
                    errors={errors}
                    onChange={change}
                  />
                  <CardSpacer />

                  <Metadata data={data} onChange={handlers.changeMetadata} />
                </div>
              </Grid>
              <SaveButtonBar
                // disabled={loading || !hasChanged}
                state={saveButtonBarState}
                onCancel={onBack}
                onDelete={onDelete}
                onSave={() => {
                  submit();
                  savaSelect();
                }}
                disabled={false}
              />
            </>
          )}
        </ProductVariantUpdateForm>
      </Container>
    </>
  );
};
ProductVariantPage.displayName = "ProductVariantPage";
export default ProductVariantPage;
